module.exports = __webpack_public_path__ + "static/egyptian-bedding-set-navy-1-86aa8983eebdbd21eff5530fb681cc0c.webp";